import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

// Wires react-router's navigate() into the AuthContext so the context can
// redirect to /login on 401 without depending on react-router directly.
// MUST be rendered inside a <Router> tree because of useNavigate().
export default function NavigatorBridge() {
  const navigate = useNavigate();
  const { setNavigator } = useAuth();

  useEffect(() => {
    setNavigator((path) => navigate(path));
  }, [navigate, setNavigator]);

  return null;
}
